import { API } from '../configs/axios/axios.config'
import { createSearchParams } from '../utils/request.helper'

const GET_ASSIGNMENTS_ENDPOINT = '/assignments/get-assignments'
const UPDATE_HIDE_GRADING_ENDPOINT = token => `/assignment/${token}/update-hide-grading`
const DELETE_ASSIGNMENT_ENDPOINT = token => `/assignments/${token}/delete-assignment`
const UPLOAD_ZIP_ENDPOINT = '/assignments-upload/upload-zip-cs'
const UPLOAD_EXCEL_ENDPOINT = '/assignments-upload/upload-xlsx'
const UPDATE_STARTER_CODE_ENDPOINT = token => `/assignment-metadata/${token}/update-starter-code`
const UPDATE_INSTRUCTIONS_ENDPOINT = token => `/assignment-metadata/${token}/update-instructions`
const GET_STARTER_CODE_ENDPOINT = token => `/assignment-metadata/${token}/get-starter-code`
const GET_INSTRUCTIONS_ENDPOINT = token => `/assignment-metadata/${token}/get-instructions`
const CONVERT_TO_MODEL_ENDPOINT = token => `/assignment/${token}/convert-to-model`
const GET_MODELS_ENDPOINT = '/assignments/get-models'
const CREATE_PREDEFINED_ASSIGNMENT_ENDPOINT = '/assignments-upload/create-model-bounded-assignment'
const UPDATE_ASSIGNMENT_NAME_ENDPOINT = token => `/assignments/${token}/update-assignment-name`
const MIGRATE_MBA_VERSION_ENDPOINT = token => `/versions/${token}/switch-mba-version`
const GET_ASSIGNMENTS_PROGRESS_ENDPOINT = `/assignments/get-assignments-progress`
const COPY_ASSIGNMENT_ENDPOINT = token => `/assignments-upload/${token}/copy`
const GET_EXCEL_SHEETS_ENDPOINT = '/internal/get-excel-sheets'

class _AssignmentsService {
    getAssignments(name, sort, type, language, page, pageSize, organizationIds, courseIds, searchType = 1) {
        const params = createSearchParams({
            sort_by: sort,
            name,
            page,
            page_size: pageSize,
            assignment_type: type,
            language,
            organization_used_ids: organizationIds,
            course: courseIds,
            search_type: searchType,
        })

        return API.get(GET_ASSIGNMENTS_ENDPOINT, { params })
    }

    updateHideGrading(token, hideGrading) {
        return API.put(UPDATE_HIDE_GRADING_ENDPOINT(token), {
            hide_grading: hideGrading,
        })
    }

    uploadZip(file, name, assignmentType, assignmentToken) {
        const formData = new FormData()
        formData.append('zip_file', file)
        formData.append('assignment_name', name)
        formData.append('assignment_type', assignmentType)
        if (assignmentToken !== undefined && assignmentToken !== null)
            formData.append('assignment_token', assignmentToken)

        return API.post(UPLOAD_ZIP_ENDPOINT, formData)
    }

    uploadExcel(excelFile, zipFile, name, sheetTypes) {
        const formData = new FormData()
        formData.append('excel_file', excelFile)
        formData.append('zip_file', zipFile)
        formData.append('assignment_name', name)
        formData.append('sheet_types', JSON.stringify(sheetTypes))

        return API.post(UPLOAD_EXCEL_ENDPOINT, formData)
    }

    deleteAssignment(token) {
        return API.delete(DELETE_ASSIGNMENT_ENDPOINT(token))
    }

    createPredefinedAssignment(modelToken, versionId, assignmentName) {
        return API.post(CREATE_PREDEFINED_ASSIGNMENT_ENDPOINT, {
            model_token: modelToken,
            version_id: versionId,
            assignment_name: assignmentName,
        })
    }

    migrateMBAVersion(token, versionId) {
        return API.put(MIGRATE_MBA_VERSION_ENDPOINT(token), { version_id: versionId })
    }

    convertToModel(token) {
        return API.put(CONVERT_TO_MODEL_ENDPOINT(token), {})
    }

    updateStarterCode(token, code) {
        return API.put(UPDATE_STARTER_CODE_ENDPOINT(token), { starter_code: code })
    }

    updateInstructions(token, instructions) {
        return API.put(UPDATE_INSTRUCTIONS_ENDPOINT(token), { instructions })
    }

    getStarterCode(token) {
        return API.get(GET_STARTER_CODE_ENDPOINT(token))
    }

    getInstructions(token) {
        return API.get(GET_INSTRUCTIONS_ENDPOINT(token))
    }

    updateAssignmentName(token, assignmentName) {
        return API.put(
            UPDATE_ASSIGNMENT_NAME_ENDPOINT(token),
            {},
            {
                params: {
                    name: assignmentName,
                },
            },
        )
    }

    getModels() {
        return API.get(GET_MODELS_ENDPOINT)
    }

    getAssignmentsProgress(listOfTokens) {
        return API.post(GET_ASSIGNMENTS_PROGRESS_ENDPOINT, { assignments: listOfTokens })
    }

    copyAssignment(token, userId, assignmentName) {
        return API.post(COPY_ASSIGNMENT_ENDPOINT(token), {
            user_id: userId,
            assignment_name: assignmentName,
        })
    }

    getExcelSheets(file) {
        const formData = new FormData()
        formData.append('excel_file', file)

        return API.post(GET_EXCEL_SHEETS_ENDPOINT, formData)
    }
}

const AssignmentsService = new _AssignmentsService()
export default AssignmentsService
